# F63 — Asset Class YAML editor screen
# Route: /asset/classes/:id

page-config-asset-class-editor:
  type: Page
  archetype: edit
  meta:
    title: $t.config_asset_class.editor_title
    route: /asset/classes/:id
    layout: shell
    auth: required
  params:
    id:
      type: string
      required: true
  # Header-only read of the edited class: id + name feed the composed PageHeader
  # title ("Asset Class › {name}"). The YAML editor panel fetches its own full
  # config blob; this keyed read (GET /api/asset/classes/:id) supplies just the
  # name for the header. AssetClassOption is the id+name read model.
  data:
    assetClass:
      model: AssetClassOption
      key: $route.id
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - config-ac-editor-sm-notice
    - config-ac-editor-content

config-ac-editor-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_desktop

config-ac-editor-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - config-ac-editor-header
    - config-ac-editor-panel

config-ac-editor-header:
  type: PageHeader
  back_route: /asset/classes
  title_prefix: $t.config_asset_class.title_prefix
  bind:
    content: assetClass.name
  # F79 canonical /audit deep-link (screen-guide.md §6c) — new button per the
  # M1 manual test pass (Act 2.2): "we miss the audit trail button, in the
  # audit record of the classes". `/asset/classes/new` is the
  # create-mode sentinel route (config-asset-class-list.cir.yaml) — ideally
  # this button would hide there (no audit trail exists yet for an entity
  # that has not been created), but `visible_when:` on a PageHeader `actions:`
  # item is confirmed unwired in the pinned XP85 build (emit shows the
  # predicate silently dropped, button always rendered) — accepted edge case:
  # clicking it in create mode opens /audit pre-filtered to an id that
  # doesn't exist yet, which returns an empty (not broken) list.
  actions:
    - label: $t.config_asset_class.btn_audit
      route: /audit
      query:
        entityType: AssetClass
        entityId: $route.id
      return_context: origin_only
      variant: ghost

config-ac-editor-panel:
  type: Widget
  ref: xp87-yaml-config-editor
  params:
    entity-type: asset-classes
    entity-id: $params.id
  spatial:
    flex: 1
    min_height: 25rem
